import styles from "./styles.module.less";
import { parseZaloEmoji } from "@utils/zaloEmojiParser";

interface MessageTextProps {
  text: string;
  provider?: string;
}

export const MessageText = ({ text, provider }: MessageTextProps) => {
  // Only parse emoji for Zalo messages
  const content =
    provider === "zalo" ? parseZaloEmoji(text) : <span>{text}</span>;

  return <p className={styles.text}>{content}</p>;
};
